import http_news from "@/utils/http_news";

const prefixUrl = {
  list: "/news/list.html",
  detail: "/news/detail.html",
  recommendList: "/news/recommendList.html",
  bannerList: "/news/bannerList.html",
};
export default {
  queryList(params = {}) {
    return http_news.get(prefixUrl.list, { params });
  },
  queryDetail(params = {}) {
    return http_news.get(prefixUrl.detail, { params });
  },
  queryRecommendList(params = {}) {
    return http_news.get(prefixUrl.recommendList, { params });
  },
  queryBannerList(params = {}) {
    return http_news.get(prefixUrl.bannerList, { params });
  },
};
// 列表：/news/list.html?page=1&lan=EN-IN
// 详情：/news/detail.html?newsId=10713841
// 推荐的：/news/recommendList.html?lan=EN-IN&newsId=10713841
// banner：/news/bannerList.html?lan=EN-IN
